export function getPiwikTrackingSlug(path: string | null) {
	const slug = path?.split('/').pop();
	return slug === '' ? 'startsida' : slug;
}
